module.exports = __webpack_public_path__ + "static/feelingo-challenge-paper-4c88aefcd2ed2f9d90749537fd6e7f59.jpeg";